import HeaderSection from '../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../components/CockpitCards/CardTransparent';


export default function GeneticsCvdText() {

    
    return (

    <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Know your" 
            headline_grey = "cardiovascular"
            headline_p2 = "genetic predisposition"

            text1 = "Despite the rapid progress in diagnosis and treatment of cardiovascular disease (CVD), this disease remains a major cause of mortality and morbidity."
            text2 = "Although there has been substantial improvements cardiovascular diseases remain the leading cause of morbidity and mortality globally. So better know your essential parameters and manage it."

       
            />
    }/>
            
  )
}